import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils';
export function FormLabelDescription({ children, className }) {
    return (_jsx("p", { className: cn('text-body-sm text-fg-subtle mb-stack-dense', className), children: children }));
}
